import moment, { Moment } from 'moment'

export abstract class FullDate {
  private _date: Moment

  constructor (date: string) {
    this._date = moment(date, 'DD/MM/YYYY', true)
    if (!this._date.isValid()) {
      throw new TypeError(`${date} is not a valid DD/MM/YYYY format`)
    }
  }

  date (): string {
    return this._date.format('DD/MM/YYYY')
  }
}
